import axios from 'axios';

const instance = axios.create({
  //  withCredentials: true,
  baseURL: `https://${process.env.REACT_APP_NAME_SITE_API}/local/rest/organza/api/`,
  headers: {},
});
const instance2 = axios.create({
  //  withCredentials: true,
  // baseURL: `https://organza.boltua.ru/local/rest/organza/api/`,
   baseURL: `https://${process.env.REACT_APP_NAME_SITE_API}/local/rest/organza/api/`,
  headers: {},
});

export const filtrSmartCatalogAPI = {
  async getProperty(parametrs = "") {
    const response = await instance
      .get(`getProperty/${parametrs}`, {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      });
    return response.data;
  },
};

export const ItemAPI = {
  async GetItemUrlCod(itemUrlCod,clearCache="N") {
    const response = await instance
      .get(`/Item/?itemUrlCode=${itemUrlCod}&clear_cache=${clearCache}`, {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      });
    return response.data;
  },
  async DeleteItemsArhiv(go_arhiv, el_id, code) {
    const  deleteArhiv = `go_arhiv=${go_arhiv}&el_id=${el_id}&code=${code}`;
    const response = await instance2
      .post(`delit/`, deleteArhiv, {
        "Access-Control-Allow-Origin": "*",
      });
    return response.data;
  },
  async DeleteItemsColor(action, elementId, color) {
    const  deleteArhiv = `action=${action}&element_id=${elementId}&color=${color}`;
    const response = await instance2
      .post(`delit/`, deleteArhiv, {
        "Access-Control-Allow-Origin": "*",
      });
    return response.data;
  },
};

export const CatalogItemsAPI = {
  async CatalogItems(pageSize = "", currentPage = "", parametrs = "") {
    const response = await instance
      .get(`?countItems=${pageSize}&page=${currentPage}${parametrs}`, {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      });
    return response.data;
  },
  async CatalogItemsFish(p_id, pp_id, price, name, url, patchImgValue) {
    const articleFish = `p_id=${p_id}&pp_id=${pp_id}&p=${price}&name=${name}&dpu=/${url}/&patchImgValue=${patchImgValue}`;
    const response = await instance2
      .post(`basket/wishlist/`, articleFish, {
        "Access-Control-Allow-Origin": "*",
      });
    return response.data;
  },

  async BasketIdItem(BasketIdItem, quantity = 1) {
    const articleFish = `basketIdItem=${BasketIdItem}&quantity=${quantity}`;
    const response = await instance2
      .post(`basket/`, articleFish, {
        "Access-Control-Allow-Origin": "*",
      });
    return response.data;
  },
  async BasketIdItemsFish(BasketIdItems) {
    const articleFish = `basketIdItems=${BasketIdItems}`;
    const response = await instance.post(`basket/wishlist/`, articleFish, {
      "Access-Control-Allow-Origin": "*"
    });
    return response.data;
  },
  async BasketIdItemsFastOrder(
    PRODUCT_ID,
    delivery,
    NAME,
    EMAIL,
    PHONE,
    COMMENT,
    count = 1,
    isSewing
  ) {
    const fastOrder = `PRODUCT_ID=${PRODUCT_ID}&delivery=${delivery}&NAME=${NAME}&EMAIL=${EMAIL}&PHONE=${PHONE}&COMMENT=${COMMENT}&count=${count}&isSewing=${isSewing}`;
    const response = await instance2
      .post(`fastorder/`, fastOrder, {
        "Access-Control-Allow-Origin": "*",
      });
    return response.data;
  },
};

export const getItemsTagAPI = {
  async GetItemsTag() {
    const response = await instance
      .get(`getItemsTag/`, {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      });
    return response.data;
  },
};

export const UserAPI = {
  async ItemUser() {
    const response = await instance2
      .get(`user/`, {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      });
    return response.data;
  },
};

export const ItemsAPI = {

}
